import { useEffect, useState } from 'react';

import { getBranchByCode, getCompany } from '../../../../api/branchManagement]/branchApi.js';

export const useCompanyAndDispensingFee = (branchcode) => {
    const [companyName, setCompanyName] = useState('');
    const [pharmacyRegNumber, setPharmacyRegNumber] = useState('');
    const [dispensingFee, setDispensingFee] = useState(0);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const data = await getCompany();

                if (!alive || !data) return;
                setCompanyName(data.companyname || '');
                setPharmacyRegNumber(data.sapcpharmacyregnumber || '');
            } catch (e) {
            }
        })();
        return () => { alive = false; };
    }, []);

    useEffect(() => {
        const bc = branchcode;
        if (!bc) return;
        let alive = true;
        (async () => {
            try {
                const b = await getBranchByCode(bc);
                if (!alive || !b) return;
                const v = parseFloat(b.dispensingfee);
                setDispensingFee(Number.isFinite(v) ? v : 0);
            } catch (e) {
                console.error('Failed to fetch branch dispensing fee', e);
            }
        })();
        return () => { alive = false; };
    }, [branchcode]);

    return { companyName, pharmacyRegNumber, dispensingFee };
};
